import React, { useState } from 'react';
import { useQuery } from 'react-query';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';

import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import VehicleCards from '../../../../components/VehicleCards/VehicleCards.component';
import VehicleList from '../../../../components/VehicleList/VehicleList.component';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../../../query/vehicles/vehicles';

const AssistanceVehicle = () => {
  const {
    nextStep,
    updateAssistanceBody,
    // assistance_body,
  } = useAssistanceDataContext();
  const [open, setOpen] = useState(false);
  const [canRequest, setCanRequest] = useState<any>({
    available: false,
    vehicle: {},
  });
  const [isWhatsapp, setIsWhatsapp] = useState(false);
  const { user } = useAuthDataContext();

  const { data: vehicles } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );

  const handleNextStep = (vehicle: any) => {
    if (
      vehicle.assistance_provider.available &&
      vehicle.can_request_assistance
    ) {
      updateAssistanceBody({
        vehicle_id: vehicle.id,
      });
      nextStep();
    } else {
      if (vehicle.can_request_assistance) {
        setCanRequest({ available: true, vehicle });
      } else {
        setCanRequest({ available: false, vehicle });
      }
      setOpen(true);
    }

    setIsWhatsapp(
      (vehicle?.assistance_provider?.phone).startsWith('08') ? false : true
    );
  };

  const vehiclesToShow =
    vehicles?.filter(
      (vehicle: any) =>
        vehicle.policy.status === 'active' &&
        !!vehicle.assistance_provider?.phone
    ) || [];

  return (
    <>
      <SharedDialog
        open={open}
        content={
          <Box>
            <Typography display="block" variant="h6">
              {canRequest.available ? (
                <>
                  <Typography>
                    Para solicitar una asistencia para este vehículo por favor
                    comunícate por {isWhatsapp ? 'WhatsApp' : 'telefono'} con
                    nosotros al{' '}
                    {isWhatsapp ? (
                      <Link
                        href={`https://api.whatsapp.com/send?phone=${
                          canRequest?.vehicle?.assistance_provider?.phone ||
                          user.contact_info.outside_buenos_aires
                        }`}
                        rel="noopener"
                        target="_blank"
                      >
                        <Box display="inline">
                          <Typography noWrap display="inline" color="secondary">
                            {canRequest?.vehicle?.assistance_provider?.phone ||
                              user.contact_info.outside_buenos_aires}
                          </Typography>
                        </Box>
                      </Link>
                    ) : (
                      <Link
                        href={`tel:${
                          canRequest?.vehicle?.assistance_provider?.phone ||
                          user.contact_info.outside_buenos_aires
                        }`}
                        rel="noopener"
                        target="_blank"
                      >
                        <Box display="inline">
                          <Typography noWrap display="inline" color="secondary">
                            {canRequest?.vehicle?.assistance_provider?.phone ||
                              user.contact_info.outside_buenos_aires}
                          </Typography>
                        </Box>
                      </Link>
                    )}
                  </Typography>
                </>
              ) : (
                'Ya solicitaste una asistencia'
              )}
            </Typography>
            <Typography>
              {!canRequest.available &&
                'Solo podés pedir una asistencia a la vez'}
            </Typography>
          </Box>
        }
        onClose={() => setOpen(false)}
        actions={
          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography variant="h6" color="textPrimary">
              ¿Qué vehículo necesita asistencia?
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {vehiclesToShow.length > 10 ? (
            <Grid container justify="center" alignItems="center">
              <Grid item xs={11}>
                <VehicleList
                  setFunction={handleNextStep}
                  verified
                  showOnAssistance={true}
                ></VehicleList>
              </Grid>
            </Grid>
          ) : (
            <Grid container justify="center" alignItems="center">
              <Grid item xs={11}>
                <VehicleCards
                  setFunction={handleNextStep}
                  verified
                  showOnAssistance={true}
                ></VehicleCards>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default AssistanceVehicle;
